import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function CTABand() {
  return (
    <section data-testid="cta-band" className="py-24 md:py-28 bg-teh-bg">
      <div className="teh-container">
        <div className="relative overflow-hidden rounded-3xl bg-teh-navy text-white px-8 py-16 md:px-16 md:py-24">
          <div
            className="absolute -top-20 -right-20 w-96 h-96 rounded-full opacity-20"
            style={{ background: "radial-gradient(circle, #0E7A3D 0%, transparent 70%)" }}
          />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-emerald-300">
                Partner with 1st Touch
              </p>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.05] tracking-tight">
                Looking for a healthcare partner
                <br />
                <span className="italic text-emerald-300">who shows up?</span>
              </h2>
            </div>
            <div className="lg:col-span-5 lg:text-right flex flex-col lg:items-end gap-4">
              <Link
                to="/contact"
                data-testid="cta-band-primary"
                className="inline-flex items-center gap-2 px-7 py-4 bg-white text-teh-navy text-sm font-medium rounded-full hover:bg-emerald-300 hover:gap-3 transition-all duration-300"
              >
                Start a conversation
                <ArrowRight className="w-4 h-4" strokeWidth={1.8} />
              </Link>
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                data-testid="cta-band-call"
                className="inline-flex items-center gap-2 text-white/80 hover:text-white text-sm"
              >
                <Phone className="w-4 h-4" strokeWidth={1.8} />
                Or call {COMPANY.phone}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
